<template>
  <q-table
    flat
    bordered
    :data="creativeLogs"
    row-key="id"
    :columns="creativeLogColumns"
    :pagination.sync="pagination"
    class="sticky-column-table"
  >
    <template v-slot:body-cell-user_name="props">
      <q-td :props="props" style="max-width: 180px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.user_name }}
        </q-tooltip>
        {{ props.row.user_name }}
      </q-td>
    </template>

    <template v-slot:body-cell-user_email="props">
      <q-td :props="props" style="max-width: 200px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.user_email }}
        </q-tooltip>
        {{ props.row.user_email }}
      </q-td>
    </template>

    <template v-slot:body-cell-creative_name="props">
      <q-td :props="props" style="max-width: 180px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.creative_name }}
        </q-tooltip>
        {{ props.row.creative_name }}
      </q-td>
    </template>

    <template v-slot:body-cell-functionality="props">
      <q-td :props="props" style="max-width: 220px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.functionality }}
        </q-tooltip>
        {{ props.row.functionality }}
      </q-td>
    </template>

    <template v-slot:body-cell-user_agent="props">
      <q-td :props="props" style="max-width: 220px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.user_agent }}
        </q-tooltip>
        {{ props.row.user_agent }}
      </q-td>
    </template>

    <template v-slot:body-cell-geolocation="props">
      <q-td :props="props" style="max-width: 180px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.geolocation }}
        </q-tooltip>
        {{ props.row.geolocation }}
      </q-td>
    </template>

    <template v-slot:body-cell-old_value="props">
      <q-td :props="props" style="max-width: 240px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.old_value }}
        </q-tooltip>
        {{ props.row.old_value }}
      </q-td>
    </template>

    <template v-slot:body-cell-new_value="props">
      <q-td :props="props" style="max-width: 240px" class="ellipsis">
        <q-tooltip content-class="bg-secondary text-white" content-style="font-size: 12px">
          {{ props.row.new_value }}
        </q-tooltip>
        {{ props.row.new_value }}
      </q-td>
    </template>

    <template v-slot:bottom>
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        <div class="row items-center">
          <span class="q-mr-md">{{ $t('rows_per_page') }}</span>
          <q-select
            v-model="pagination.rowsPerPage"
            :options="[10, 20, 50, 100]"
            dense
            @input="onRowsPerPageChange"
            style="max-width: 60px; padding-left: 8px; padding-right: 8px"
          />
          <span>Total: {{ reqPagination.total || 0 }}</span>
        </div>
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page || 1"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
  </q-table>
</template>

<script>
import CreativeLogMixin from '../../mixins/CreativeLogMixin';

export default {
  name: 'ListCreativeLog',
  mixins: [CreativeLogMixin],
  data() {
    return {
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: Number(localStorage.getItem('rowsPerPage')) || 10
      }
    };
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getCreativeLogs(`page=${this.currentPage}`, `%26perPage=${this.pagination.rowsPerPage}`);
      }
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page || 1;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  methods: {
    onRowsPerPageChange(value) {
      localStorage.setItem('rowsPerPage', value);
      this.getCreativeLogs('page=1', `%26perPage=${value}`);
    }
  },

  created() {
    this.getCreativeLogs();
  }
};
</script>
